<template>
	<div class="one">
		<div class="nr" >
			<div class="nr-1">
				<img class="nr-1-0" src="../../../static/img/login/xiaojie.png" />
				<input class="nr-1-1 inp" v-model="user.username" size="large" placeholder="请输入用户名"  />
				<input class="nr-1-2 inp" v-model="user.password" type="password" size="large" placeholder="请输入密码"  />
				<Button class="nr-1-3" @click="dl" >登录</Button>

			</div>
			<div class="nr-4" ref="qrCodeIosDiv">

			</div>
			<div class="nr-5">
				<div class="nr-5-1">
					<img class="nr-5-1-1" src="../../../static/img/login/ios.png"/>
					<div class="nr-5-1-2">支持ios</div>
				</div>
				<div class="nr-5-2">
					<img class="nr-5-2-1" src="../../../static/img/login/anzhuo.png"/>
					<div class="nr-5-2-2">支持Android</div>
				</div>
			</div>




		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import QRCode  from "qrcodejs2"
	export default {
		data() {
			return {
				app:true,
				url:"https://admin.xaojer.cn/xj/xiaojie_houtai.html",
				a:0,
				user: {
					username: '',
					password: ''
				},
				clientHeight: window.innerHeight
			};
		},
		components: { QRCode },
		methods: {
			mouseenter1(){
				let _this=this
				_this.app=true
				if(_this.a==0){
					_this.a++
					new QRCode(_this.$refs.qrCodeIosDiv1, {
					  text:_this.url,
					  width: 300,
					  height: 300,
					  colorDark: "#333333", //二维码颜色
					  colorLight: "#ffffff", //二维码背景色
					  correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
					})
				}

			},
			 //  生成二维码
			bindQRCode () {
				let _this=this
				new QRCode(_this.$refs.qrCodeIosDiv, {
				  text:_this.url,
				  width: 130,
				  height: 130,
				  colorDark: "#333333", //二维码颜色
				  colorLight: "#ffffff", //二维码背景色
				  correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
				})

				// http.http({
				//     //这里是你自己的请求方式、url和data参数
				//     method: 'post',
				//     url: http.url + '/app/vesions/getNewest',
				//     data: {
				// 		appType:'HOUTAIAPP'
				// 	},
				// 	_this:_this,
				// 	success:function(data){
				// 		console.log(data.map.url)
				// 		_this.androidUrl=data.map.url
				// 		new QRCode(_this.$refs.qrCodeDivAndroid, {
				// 		  text:_this.androidUrl,
				// 		  width: 50,
				// 		  height: 50,
				// 		  colorDark: "#333333", //二维码颜色
				// 		  colorLight: "#ffffff", //二维码背景色
				// 		  correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
				// 		})
				// 		new QRCode(_this.$refs.qrCodeDivAndroid2, {
				// 		  text:_this.androidUrl,
				// 		  width: 300,
				// 		  height: 300,
				// 		  colorDark: "#333333", //二维码颜色
				// 		  colorLight: "#ffffff", //二维码背景色
				// 		  correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
				// 		})
				// 	}
				// })

			},
			dl() {
				let _this=this
				if (_this.user.username == '' || _this.user.password == '') {
					_this.$Message.error('请输入用户名和密码!')
					return;
				}
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/login',
				    data: _this.user,
					_this:_this,
					success:function(data){
						console.log(data,'登录信息')
						let u = {
							username: _this.user.username,
							password: _this.user.password,
							type: data.user.typeId,
							empName: data.user.empName,
							empType:data.user.empType,
							userType: data.user.userType,
							operId:data.user.operId
						}
						sessionStorage.setItem("user", JSON.stringify(u))
						_this.$Message.success('登陆成功!')
						_this.$router.push('/home')
					}
				  })



			}
		},
		mounted: function () {

		},
		created() {
			document.title = '小捷智购管理平台'
			console.log(document.documentElement.clientHeight)
			this.clientHeight = document.documentElement.clientHeight
			this.$nextTick(function () {
				this.bindQRCode();
			})

			//监听回车键
		/* 	var _this = this;
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key == 13) {
					_this.dl();
				}
			}; */
		}
	};
</script>

<style scoped="scoped" lang="less">
	.inp {
		border: 0; // 去除未选中状态边框
		outline: none; // 去除选中状态边框
		background-color: #ffffff; // 透明背景

		border: 1px solid #EEEEEE;
		font-size: 20px;
		padding: 14px 14px;
		color: #999999;
	}
	input::-webkit-input-placeholder{
	    font-size: 20px;
	    color: #999999;
	}
	.one {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: center;
		height: 100%;

		.nr {
				display: flex;
				flex-direction: column;
				align-items: center;
				margin-bottom: 30px;
				.nr-1{
					width: 45vw;
					height: 55vh;
					background-color: #FFFFFF;
					display: flex;
					flex-direction: column;
					align-items: center;
          justify-content: space-around;
					border-radius: 8px;
					.nr-1-0{
						width: 15vw;
            height: 15vh;
					}
					.nr-1-1{
						width: 37vw;
						height: 7vh;
						border-radius: 8px;
					}
					.nr-1-2{
						width: 37vw;
						height: 7vh;
						border-radius: 8px;
					}
					.nr-1-3{
						width: 37vw;
						height: 7vh;
						border-radius: 8px;
						font-size: 24px;
						background-color: #0091FF;
						color: #FFFFFF;
						display: flex;
						justify-content: center;
						align-items: center;
					}
				}
				.nr-4{
					margin-top: 30px;
				}
				.nr-5{
					display: flex;
					margin-top: 20px;
					.nr-5-1{
						display: flex;
						flex-direction: column;
						align-items: center;
						.nr-5-1-1{
							width: 45px;
							height: 45px;
						}
						.nr-5-1-2{
							font-size: 20px;
							color: #FFFFFF;
						}
					}
					.nr-5-2{
						margin-left: 20px;
						display: flex;
						flex-direction: column;
						align-items: center;
						.nr-5-2-1{
							width: 45px;
							height: 45px;
						}
						.nr-5-2-2{
							font-size: 20px;
							color: #FFFFFF;
						}
					}
				}
			}

	}
</style>
<style>
	html,
	body,
	#app {
		margin: 0;
		padding: 0;
		width: 100%;
		height: 100%;
	}

	body {
		background: url(../../../static/img/login/biejing.png);
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue